// extracted by mini-css-extract-plugin
export default {"container":"CD-z","innerContainer":"DD-z","multipleLines":"ED-z","heading":"FD-z","content":"GD-z","linkColor":"HD-z"};